import {Routes, Route, useLocation} from 'react-router-dom';
import clsx from 'clsx';

import './styles/main.scss';
import HeaderUser from './components/HeaderUser';
import ChoseServer from './components/chooseSrver/ChoseServer';
import ChatComponent from './components/chat/ChatComponent';
import RecoverPage from './components/RecoverServer/RecoverPage';
import NotificationPage from './components/notification/NotificationPage';
import DashboardWrap from './components/dashboard/DashboardWrap';
import './fonts/Muller/stylesheet.css';
import './fonts/Gg Sans/stylesheet.css';
import './fonts/Menlo/stylesheet.css';
import {routes} from './constants/routes';
import {Home} from './pages/Home';
import {Features} from './pages/Features';
import {Premium} from './pages/Premium';
import {ChangeLog} from './pages/ChangeLog';
import {Footer} from './components/Footer';
import {Navigation} from './components/Navigation';
import {
  includePathsHeaderUser,
  includePathsNavigation,
  includePathsFooter,
  includePathsChat,
  includeLayout,
  excludeTipForAdaptive,
} from './constants/routes';
import {Success} from './pages/Success';
// import {useStats} from './hooks/useStats';
// import {Loader} from './components/Loader';

function App() {
  const {pathname} = useLocation();
  // const {stats, loading} = useStats();

  const isHeaderVisible = includePathsHeaderUser.some((path) => pathname.includes(path));
  const isNavigationVisible = includePathsNavigation.some((path) => pathname === path);
  const isFooterVisible = includePathsFooter.some((path) => pathname === path);
  const isChatVisible = includePathsChat.some((path) => pathname === path);
  const isTipForAdaptiveVisible = excludeTipForAdaptive.some((path) => pathname === path);
  const isLayout = includeLayout.some((path) => pathname === path);

  // if (loading) return <Loader />;

  return (
    <div className="App">
      {isHeaderVisible && <HeaderUser />}
      {isNavigationVisible && <Navigation />}
      <div className={clsx('page', {layout: isLayout})}>
        {!isTipForAdaptiveVisible && (
          <div className="tip_for_adaptive">
            <h1>
              Sorry, the mobile version is still under development. For correct display, switch the
              phone to landscape mode
            </h1>
          </div>
        )}
        <Routes>
          <Route path={routes.home} element={<Home />} />
          <Route path={routes.features} element={<Features />} />
          <Route path={routes.premium} element={<Premium />} />
          <Route path={routes.changelog} element={<ChangeLog />} />
          <Route path={routes.chooseServer} element={<ChoseServer />} />
          <Route path={routes.recovery} element={<RecoverPage />} />
          <Route path={routes.notification} element={<NotificationPage />} />
          <Route path={routes.dashboard + '/:id'} element={<DashboardWrap />} />

          <Route path={routes.success} element={<Success />} />
        </Routes>
      </div>

      {isChatVisible && <ChatComponent />}
      {isFooterVisible && <Footer />}
    </div>
  );
}

export default App;
